import { Button } from '@/components/ui/button';
import { SessionStatusChangeModal } from './session-status-change-modal';
import { AdminSession, SessionStatus } from '@airreading/common/data';

interface SessionStartButtonProps {
  session: AdminSession;
  trigger?: React.ReactNode;
}

export const SessionStartButton = ({ session, trigger }: SessionStartButtonProps) => {
  if (session.status === SessionStatus.cancelled) {
    return null;
  }

  return (
    <SessionStatusChangeModal
      sessions={[session]}
      trigger={
        trigger || (
          <Button variant="outline" className="bg-slate-100 hover:bg-slate-200">
            Start session
          </Button>
        )
      }
      targetStatus={SessionStatus.in_progress}
      modalTitle="Start Session"
      noValidSessionsTitle="Start Session"
      confirmBtnLabel="Start session"
      description="Are you sure you want to start this session?"
      noValidSessionsMessage="This session cannot be started."
      invalidSessionsMessage="This session cannot be started."
      buttonVariant="destructive"
    />
  );
};
